/**
 * Davet bağlantısı.
 *
 * Uygulama kendi alan adının kökünde olduğu için yol doğrudan
 * "/join/<kod>". (Eskiden "/program/join/<kod>" idi.)
 */
export function getInviteUrl(code: string): string {
  return `${window.location.origin}/join/${code}`;
}

export async function copyInviteLink(code: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(getInviteUrl(code));
    return true;
  } catch {
    /* Panoya yazma izni yoksa (eski tarayıcı, güvensiz bağlam) çağıran
       taraf bağlantıyı ekranda gösteriyor. */
    return false;
  }
}
